import AM from './locales/am/translation'
import AR from './locales/ar/translation'
import BG from './locales/bg/translation'
import BN from './locales/bn/translation'
import CA from './locales/ca/translation'
import CS from './locales/cs/translation'
import DA from './locales/da/translation'
import DE from './locales/de/translation'
import EL from './locales/el/translation'
import EN from './locales/en/translation'
import ES from './locales/es/translation'
import ET from './locales/et/translation'
import FA from './locales/fa/translation'
import FI from './locales/fi/translation'
import FIL from './locales/fil/translation'
import FR from './locales/fr/translation'
import GU from './locales/gu/translation'
import HE from './locales/he/translation'
import HI from './locales/hi/translation'
import HR from './locales/hr/translation'
import HU from './locales/hu/translation'
import ID from './locales/id/translation'
import IT from './locales/it/translation'
import JA from './locales/ja/translation'
import KN from './locales/kn/translation'
import KO from './locales/ko/translation'
import LT from './locales/lt/translation'
import LV from './locales/lv/translation'
import ML from './locales/ml/translation'
import MR from './locales/mr/translation'
import MS from './locales/ms/translation'
import NB from './locales/nb/translation'
import NL from './locales/nl/translation'
import PL from './locales/pl/translation'
import PT from './locales/pt/translation'
import RO from './locales/ro/translation'
import RU from './locales/ru/translation'
import SK from './locales/sk/translation'
import SL from './locales/sl/translation'
import SR_CYRL from './locales/sr-Cyrl/translation'
import SR_LATN from './locales/sr-Latn/translation'
import SV from './locales/sv/translation'
import SW from './locales/sw/translation'
import TA from './locales/ta/translation'
import TE from './locales/te/translation'
import TH from './locales/th/translation'
import TR from './locales/tr/translation'
import UK from './locales/uk/translation'
import VI from './locales/vi/translation'
import ZH from './locales/zh/translation'
import ZH_HANT from './locales/zh-Hant/translation'

const resources = {
  am: { translation: AM },
  ar: { translation: AR },
  bg: { translation: BG },
  bn: { translation: BN },
  ca: { translation: CA },
  cs: { translation: CS },
  da: { translation: DA },
  de: { translation: DE },
  el: { translation: EL },
  en: { translation: EN },
  es: { translation: ES },
  et: { translation: ET },
  fa: { translation: FA },
  fi: { translation: FI },
  fil: { translation: FIL },
  fr: { translation: FR },
  gu: { translation: GU },
  he: { translation: HE },
  hi: { translation: HI },
  hr: { translation: HR },
  hu: { translation: HU },
  id: { translation: ID },
  it: { translation: IT },
  ja: { translation: JA },
  kn: { translation: KN },
  ko: { translation: KO },
  lt: { translation: LT },
  lv: { translation: LV },
  ml: { translation: ML },
  mr: { translation: MR },
  ms: { translation: MS },
  nb: { translation: NB },
  nl: { translation: NL },
  pl: { translation: PL },
  pt: { translation: PT },
  ro: { translation: RO },
  ru: { translation: RU },
  sk: { translation: SK },
  sl: { translation: SL },
  'sr-Cyrl': { translation: SR_CYRL },
  'sr-Latn': { translation: SR_LATN },
  sv: { translation: SV },
  sw: { translation: SW },
  ta: { translation: TA },
  te: { translation: TE },
  th: { translation: TH },
  tr: { translation: TR },
  uk: { translation: UK },
  vi: { translation: VI },
  zh: { translation: ZH },
  'zh-Hant': { translation: ZH_HANT },
}

export default resources
